// // import { handleKeyDown } from "_services";
// // import { CommonInput, CommonModal, CustomSelect } from "components";
// // import { UserContext } from "context";
// // import { addTotalFrieght, editTotalFrieght } from "features";
// // import { errorSchema, utils } from "helper";
// // import React, { useContext, useEffect, useState } from "react";
// // import { useDispatch } from "react-redux";
// // import StorageService from "utils/StorageServices/StorageServices";

// // const AddTotalFreightModal = (props) => {
// //   const { editData } = props;

// //   const intialTotal = {
// //     trip_id: props?.tripId,
// //     freight_type: 6,
// //     qty: "",
// //     rate: "",
// //     amount: "",
// //     tds_diduction: 0,
// //   };
// //   const dispatch = useDispatch();
// //   const { masterData } = useContext(UserContext);
// //   const [tdsChecked, setTdsChecked] = useState(false);
// //   const [tdsList, setTDsList] = useState([]);
// //   const [formTotal, setFormTotal] = useState(intialTotal);
// //   const [formTotalName, setFormTotalName] = useState(intialTotal);
// //   const [formError, setFormError] = useState("");
// //   const [isLoading, setIsLoading] = useState(false);
// //   const [freightTypeList, setFreightTypeList] = useState([]);
// //   const [tdsAmmount, setTdsAmmount] = useState(0);

// //   useEffect(() => {
// //     if (masterData) {
// //       const Tds = masterData.tds_section_list?.map((item) => {
// //         return { label: item?.name, value: item?.id };
// //       });
// //       const lrFreight = masterData?.contract_rate_type_list?.map((item) => {
// //         return { label: item?.name, value: item?.id };
// //       });
// //       setTDsList(Tds);
// //       setFreightTypeList(lrFreight);
// //       setFormTotal({ ...formTotal, trip_id: props?.tripId });
// //     }
// //   }, [masterData]);

// //   useEffect(() => {
// //     if (props?.totalFreightDetails || editData) {
// //       setFormTotal({
// //         ...formTotal,
// //         amount: editData?.total_freight
// //           ? editData?.total_freight
// //           : props?.totalFreightDetails?.balance,
// //         rate: editData?.rate ? editData?.rate : props?.totalFreightDetails?.rate,
// //         qty: editData?.qty ? editData?.qty : props?.totalFreightDetails?.qty,
// //         freight_type: editData?.freight_type
// //           ? editData?.freight_type
// //           : props?.totalFreightDetails?.freight_type,
// //         tds_diduction: editData?.tds_deduction
// //           ? editData?.tds_deduction
// //           : props?.totalFreightDetails?.tds_deduction,
// //       });
// //       if (
// //         editData
// //           ? editData?.tds_deduction
// //           : props?.totalFreightDetails?.tds_deduction > 0
// //       ) {
// //         setTdsChecked(true);
// //       }
// //     }
// //   }, [props?.totalFreightDetails, editData]);

// //   useEffect(() => {
// //     setFormTotal((prev) => ({
// //       ...prev,
// //       tds_diduction: tdsChecked ? 1 : 0,
// //       trip_id: props?.tripId,
// //     }));

// //     setFormTotalName((prev) => ({
// //       ...prev,
// //       tds_diduction: tdsChecked
// //         ? { label: "1%", value: "1" }
// //         : { label: "", value: "" },
// //     }));
// //   }, [tdsChecked, props?.tripId]); // Added `props?.tripId` to avoid stale closure

// //   useEffect(() => {
// //     if (formTotal?.freight_type !== 6) {
// //       setFormTotal((prev) => ({
// //         ...prev,
// //         amount: Number(prev?.qty) * Number(prev?.rate),
// //       }));
// //     }
// //   }, [formTotal.rate, formTotal.qty]); // Removed unnecessary optional chaining

// //   useEffect(() => {
// //     setFormTotal((prev) => ({
// //       ...prev,
// //       rate: prev.freight_type === 6 ? "" : prev.rate || "",
// //       qty: prev.freight_type === 6 ? "" : prev.qty || "",

// //     }));
// //   }, [formTotal.freight_type]); // Added dependency to avoid stale closure

// //   useEffect(() => {
// //     setTdsAmmount((formTotal?.amount * formTotal?.tds_diduction) / 100 || 0);
// //   }, [formTotal]);

// //   const handleOnChange = async (name, value) => {
// //     const stateObj = {
// //       ...formTotal,
// //       [name]: value,
// //     };
// //     setFormTotal(stateObj);

// //     if (!!formError) {
// //       const validationResult = await utils.checkFormError(
// //         { ...stateObj },
// //         errorSchema.addTotalFreigthSchema
// //       );
// //       if (validationResult === true) {
// //         setFormError("");
// //       } else {
// //         setFormError(validationResult);
// //       }
// //     }
// //   };

// //   const onSubmitTotal = async () => {
// //     const validationResult = await utils.checkFormError(
// //       { ...formTotal },
// //       errorSchema.addTotalFreigthSchema
// //     );
// //     const payload = {
// //       company_id: StorageService?.getCompanyId(),
// //       trip_id: props?.tripId,
// //       freight_type: formTotal?.freight_type,
// //       qty: Number(formTotal?.qty),
// //       rate: Number(formTotal?.rate),
// //       amount: Number(formTotal?.amount),
// //       tds_diduction: formTotal?.tds_diduction ? formTotal?.tds_diduction : 0,
// //     };
// //     try {
// //       if (validationResult === true) {
// //         setIsLoading(true);
// //         const isNewFreight = props?.totalFreightDetails || editData;
// //         const action = !isNewFreight ? addTotalFrieght : editTotalFrieght;
// //         const res = await dispatch(action(payload));
// //         if (res?.payload?.responseCode === 200) {
// //           setIsLoading(false);
// //           handleCloseTotal();
// //           props.callbackTotal();
// //         } else {
// //           setIsLoading(false);
// //         }
// //       } else {
// //         setIsLoading(false);
// //         setFormError(validationResult);
// //       }
// //     } catch {
// //       setIsLoading(false);
// //     }
// //   };

// //   const allClear = () => {
// //     setFormTotal({ ...intialTotal });
// //   };
// //   const handleCloseTotal = () => {
// //     props?.closeModal();
// //     allClear();
// //   };

// //   const modifyProps = {
// //     ...props,
// //     onSubmit: onSubmitTotal,
// //     isLoading: isLoading,
// //     disabled:  isLoading
// //   };
// //   return (
// //     <div>
// //       <CommonModal {...modifyProps}>
// //         <div className="addTotalFreight_body">
// //           <div className="_qntSelector">
// //             <CustomSelect
// //               label="Freight Type"
// //               options={freightTypeList?.length ? freightTypeList : []}
// //               onSelect={(data) => handleOnChange("freight_type", data?.value)}
// //               value={freightTypeList?.find(
// //                 (i) => i?.value === formTotal?.freight_type
// //               )}
// //               focus={!!formError?.freight_type}
// //               error={formError.freight_type}
// //             />
// //           </div>

// //           {formTotal?.freight_type !== 6 ? (
// //             <div className="_clmsFlex">
// //               <div className="clmDual_fx">
// //                 <CommonInput
// //                   type="text"
// //                   name="qty"
// //                   value={formTotal.qty}
// //                   // onChange={({ target: { name, value } }) => {
// //                   //   // Only allow: empty, whole numbers, or numbers with up to 2 decimals
// //                   //   const regex = /^(\d+(\.\d{0,2})?)?$/;
// //                   //   if (regex.test(value)) {
// //                   //     handleOnChange(name, value);
// //                   //   }
// //                   // }}
// //                   onChange={({ target: { name, value } }) => {
// //                     if (/^0[0-9]/.test(value)) {
// //                       value = value.replace(/^0+/, ''); // "01" → "1"
// //                     }

// //                     // Allow "0." for decimals but not "0x" where x is digit
// //                     if (value === "0") {
// //                       handleOnChange(name, value);
// //                       return;
// //                     }
// //                     handleOnChange(name, value)
// //                   }}
// //                   label={
// //                     freightTypeList.length
// //                       ? freightTypeList?.find(
// //                         (i) => i?.value === formTotal?.freight_type
// //                       ).label
// //                       : "Qty"
// //                   }
// //                   maxLength={12}
// //                   onKeyDown={handleKeyDown}
// //                   focus={!!formError?.qty}
// //                   error={formError.qty}
// //                 />
// //               </div>
// //               <div className="clmDual_fx">
// //                 <CommonInput
// //                   type="text"
// //                   label="Rate"
// //                   name="rate"
// //                   maxLength={12}
// //                   value={formTotal.rate}
// //                   // onChange={({ target: { name, value } }) => {
// //                   //   const regex = /^(\d+(\.\d{0,2})?)?$/;
// //                   //   if (regex.test(value)) {
// //                   //     handleOnChange(name, value);
// //                   //   }
// //                   // }}
// //                   onChange={({ target: { name, value } }) => {
// //                     if (/^0[0-9]/.test(value)) {
// //                       value = value.replace(/^0+/, ''); // "01" → "1"
// //                     }

// //                     // Allow "0." for decimals but not "0x" where x is digit
// //                     if (value === "0") {
// //                       handleOnChange(name, value);
// //                       return;
// //                     }
// //                     handleOnChange(name, value)
// //                   }}
// //                   onKeyDown={handleKeyDown}
// //                   focus={!!formError?.rate}
// //                   error={formError.rate}
// //                 />
// //               </div>
// //             </div>
// //           ) : (
// //             <div className="">
// //               <CommonInput
// //                 type="text"
// //                 // onChange={({ target: { name, value } }) => {
// //                 //     const regex = /^(\d+(\.\d{0,2})?)?$/;
// //                 //     if (regex.test(value)) {
// //                 //       handleOnChange(name, value);
// //                 //     }
// //                 //   }}
// //                   onChange={({ target: { name, value } }) => {
// //                     if (/^0[0-9]/.test(value)) {
// //                       value = value.replace(/^0+/, ''); // "01" → "1"
// //                     }

// //                     // Allow "0." for decimals but not "0x" where x is digit
// //                     if (value === "0") {
// //                       handleOnChange(name, value);
// //                       return;
// //                     }
// //                     handleOnChange(name, value)
// //                   }}
// //                 label={
// //                   freightTypeList.length
// //                     ? freightTypeList?.find(
// //                       (i) => i?.value === formTotal?.freight_type
// //                     ).label
// //                     : "Qty"
// //                 }
// //                 maxLength={20}
// //                 onKeyDown={handleKeyDown}
// //                 placeholder="Enter Freight"
// //                 value={formTotal?.amount}
// //                 name="amount"

// //                 focus={!!formError?.amount}
// //                 error={formError.amount}
// //               />
// //             </div>
// //           )}

// //           <div className="_amtBaar">
// //             <p>Amount</p>
// //             {/* <p>{`₹ ${formTotal?.amount ?  (formTotal?.amount)?.toFixed(2) : 0.00}`}</p> */}
// //             {/* <p>{`₹ ${(formTotal?.amount || 0).toFixed(2)}`}</p> */}
// //             <p>
// //               {/* {`₹ ${(formTotal?.amount || 0)}`}₹{" "} */}
// //                   {Number(formTotal?.amount || 0).toLocaleString("en-IN", {
// //                     minimumFractionDigits: 2,
// //                     maximumFractionDigits: 2,
// //                   })}</p>
// //           </div>

// //           {/* <CommonInput
// //             type="text"
// //             label="Amount (₹)"
// //             placeholder="Enter Amount"
// //             onKeyDown={handleKeyDown}
// //             value={formTotal?.amount}
// //             onChange={(e) => handleOnChange("amount", e.target.value)}
// //           />
// //           {formError.amount  && <small className="text-danger">{formError.amount}</small>} */}

// //           {/* <div className="form-check form-switch">
// //             <input
// //             className="form-check-input"
// //             type="checkbox"
// //             id="flexSwitchCheckDefault"
// //             checked={tdsChecked}
// //             onChange={(e) => setTdsChecked(e.target.checked)}
// //             />
// //             <label className="form-check-label" for="flexSwitchCheckDefault">
// //             {tdsChecked ? "Yes" : "No"}
// //             </label>
// //             </div> */}

// //           <div>
// //             <span className="_tdsLabel">TDS Deduction</span>
// //             <div className="form-check form-switch">
// //               <input
// //                 className="form-check-input"
// //                 type="checkbox"
// //                 id="flexSwitchCheckDefault"
// //                 checked={tdsChecked}
// //                 onChange={(e) => setTdsChecked(e.target.checked)}
// //               />
// //               <label className="form-check-label" for="flexSwitchCheckDefault">
// //                 {tdsChecked ? "Yes" : "No"}
// //               </label>
// //             </div>
// //             {tdsChecked && (
// //               <CustomSelect
// //                 label="TDS Deduction %"
// //                 // value={formTotalName?.tds_diduction }
// //                 value={
// //                   formTotal?.tds_diduction !== 0
// //                     ? tdsList?.find(
// //                       (i) => i?.value === formTotal?.tds_diduction
// //                     )
// //                     : { label: "", value: "" }
// //                 }
// //                 options={tdsList}
// //                 disabled={!tdsChecked}
// //                 onSelect={(data) => {
// //                   handleOnChange("tds_diduction", data?.value);
// //                   setFormTotalName({ ...formTotalName, tds_diduction: data });
// //                 }}
// //                 focus={!!formError?.tds_diduction}
// //                 error={formError.tds_diduction}
// //               />
// //             )}

// //             {editData && <div className="_amtBaar">
// //               <p>TDS Amount</p>
// //               <p>
// //                 {/* {`₹ ${(tdsAmmount || 0).toFixed(2)}`}  ₹{" "} */}
// //                   {Number(tdsAmmount || 0).toLocaleString("en-IN", {
// //                     minimumFractionDigits: 2,
// //                     maximumFractionDigits: 2,
// //                   })}</p>
// //             </div>}
// //           </div>
// //         </div>
// //       </CommonModal>
// //     </div>
// //   );
// // };

// // export default AddTotalFreightModal;

// import { handleKeyDown } from "_services";
// import { CommonInput, CommonModal, CustomSelect } from "components";
// import { UserContext } from "context";
// import { addTotalFrieght, editTotalFrieght } from "features";
// import { errorSchema, utils } from "helper";
// import React, { useContext, useEffect, useState } from "react";
// import { useDispatch } from "react-redux";
// import StorageService from "utils/StorageServices/StorageServices";

// const INITIAL_FORM = (tripId) => ({
//   trip_id: tripId,
//   freight_type: 6,
//   qty: "",
//   rate: "",
//   amount: "",
//   tds_diduction: 0,
// });

// const sanitizeNumericValue = (value) => {
//   if (/^0[0-9]/.test(value)) return value.replace(/^0+/, "");
//   return value;
// };

// const AddTotalFreightModal = (props) => {
//   const { editData, tripId, totalFreightDetails, closeModal, callbackTotal } = props;

//   const dispatch = useDispatch();
//   const { masterData } = useContext(UserContext);

//   const [tdsChecked, setTdsChecked] = useState(false);
//   const [tdsList, setTDsList] = useState([]);
//   const [freightTypeList, setFreightTypeList] = useState([]);
//   const [formTotal, setFormTotal] = useState(INITIAL_FORM(tripId));
//   const [formError, setFormError] = useState("");
//   const [isLoading, setIsLoading] = useState(false);
//   const [tdsAmount, setTdsAmount] = useState(0);
//   const [isInitialized, setIsInitialized] = useState(false);

//   const hasPrefillTds =
//     (editData?.tds_deduction > 0) || (totalFreightDetails?.tds_deduction > 0);

//   // Load master data
//   useEffect(() => {
//     if (!masterData) return;
//     setTDsList(
//       masterData.supplier_tds_list?.map((item) => ({ label: item.name, value: item.id })) ?? []
//     );
//     setFreightTypeList(
//       masterData.contract_rate_type_list?.map((item) => ({ label: item.name, value: item.id })) ?? []
//     );
//   }, [masterData]);

//   // Sync tripId
//   useEffect(() => {
//     setFormTotal((prev) => ({ ...prev, trip_id: tripId }));
//   }, [tripId]);

//   // Pre-fill form when editing
//   useEffect(() => {
//     const source = editData || totalFreightDetails;
//     if (!source) return;

//     setFormTotal((prev) => ({
//       ...prev,
//       amount: editData?.total_freight ?? totalFreightDetails?.balance ?? "",
//       rate: editData?.rate ?? totalFreightDetails?.rate ?? "",
//       qty: editData?.qty ?? totalFreightDetails?.qty ?? "",
//       freight_type: editData?.freight_type ?? totalFreightDetails?.freight_type ?? 6,
//       tds_diduction: editData?.tds_deduction ?? totalFreightDetails?.tds_deduction ?? 0,
//     }));

//     const tdsValue = editData?.tds_deduction ?? totalFreightDetails?.tds_deduction;
//     if (tdsValue > 0) setTdsChecked(true);

//     setIsInitialized(true);
//   }, [totalFreightDetails, editData]);

//   // Auto-calculate amount from qty × rate
//   useEffect(() => {
//     if (formTotal.freight_type !== 6) {
//       setFormTotal((prev) => ({
//         ...prev,
//         amount: Number(prev.qty) * Number(prev.rate),
//       }));
//     }
//   }, [formTotal.rate, formTotal.qty]);

//   // Clear qty/rate only on user-driven freight type change
//   useEffect(() => {
//     if (!isInitialized) return;
//     if (formTotal.freight_type === 6) {
//       setFormTotal((prev) => ({ ...prev, rate: "", qty: "" }));
//     }
//   }, [formTotal.freight_type]);

//   // Recalculate TDS amount
//   useEffect(() => {
//     setTdsAmount((formTotal.amount * formTotal.tds_diduction) / 100 || 0);
//   }, [formTotal]);

//   const handleOnChange = async (name, value) => {
//     const updated = { ...formTotal, [name]: value };
//     setFormTotal(updated);

//     if (formError) {
//       const result = await utils.checkFormError(updated, errorSchema.addTotalFreigthSchema);
//       setFormError(result === true ? "" : result);
//     }
//   };

//   const handleNumericChange = ({ target: { name, value } }) => {
//     handleOnChange(name, sanitizeNumericValue(value));
//   };

//   const onSubmit = async () => {
//     const validationResult = await utils.checkFormError(formTotal, errorSchema.addTotalFreigthSchema);

//     if (validationResult !== true) {
//       setFormError(validationResult);
//       return;
//     }

//     const payload = {
//       company_id: StorageService.getCompanyId(),
//       trip_id: tripId,
//       freight_type: formTotal.freight_type,
//       qty: Number(formTotal.qty),
//       rate: Number(formTotal.rate),
//       amount: Number(formTotal.amount),
//       tds_diduction: formTotal.tds_diduction || 0,
//     };

//     try {
//       setIsLoading(true);
//       const action = totalFreightDetails || editData ? editTotalFrieght : addTotalFrieght;
//       const res = await dispatch(action(payload));
//       if (res?.payload?.responseCode === 200) {
//         handleClose();
//         callbackTotal();
//       }
//     } catch {
//       // handle silently
//     } finally {
//       setIsLoading(false);
//     }
//   };

//   const handleClose = () => {
//     closeModal();
//     setFormTotal(INITIAL_FORM(tripId));
//     setIsInitialized(false);
//     setTdsChecked(false);
//   };

//   const formatINR = (value) =>
//     Number(value || 0).toLocaleString("en-IN", {
//       minimumFractionDigits: 2,
//       maximumFractionDigits: 2,
//     });

//   const selectedFreightType = freightTypeList.find((i) => i.value === formTotal.freight_type);
//   const isFixedFreight = formTotal.freight_type === 6;

//   return (
//     <div>
//       <CommonModal {...props} onSubmit={onSubmit} isLoading={isLoading} disabled={isLoading}>
//         <div className="addTotalFreight_body">
//           <div className="_qntSelector">
//             <CustomSelect
//               label="Freight Type"
//               options={freightTypeList}
//               onSelect={(data) => handleOnChange("freight_type", data?.value)}
//               value={selectedFreightType}
//               focus={!!formError?.freight_type}
//               error={formError.freight_type}
//             />
//           </div>

//           {!isFixedFreight ? (
//             <div className="_clmsFlex">
//               <div className="clmDual_fx">
//                 <CommonInput
//                   type="text"
//                   name="qty"
//                   label={selectedFreightType?.label ?? "Qty"}
//                   value={formTotal.qty}
//                   onChange={handleNumericChange}
//                   maxLength={12}
//                   onKeyDown={handleKeyDown}
//                   focus={!!formError?.qty}
//                   error={formError.qty}
//                 />
//               </div>
//               <div className="clmDual_fx">
//                 <CommonInput
//                   type="text"
//                   name="rate"
//                   label="Rate"
//                   value={formTotal.rate}
//                   onChange={handleNumericChange}
//                   maxLength={12}
//                   onKeyDown={handleKeyDown}
//                   focus={!!formError?.rate}
//                   error={formError.rate}
//                 />
//               </div>
//             </div>
//           ) : (
//             <CommonInput
//               type="text"
//               name="amount"
//               label={selectedFreightType?.label ?? "Qty"}
//               placeholder="Enter Freight"
//               value={formTotal.amount}
//               onChange={handleNumericChange}
//               maxLength={20}
//               onKeyDown={handleKeyDown}
//               focus={!!formError?.amount}
//               error={formError.amount}
//             />
//           )}

//           <div className="_amtBaar">
//             <p>Amount</p>
//             <p>{formatINR(formTotal.amount)}</p>
//           </div>

//           <div>
//             <span className="_tdsLabel">TDS Deduction</span>

//             <div className="form-check form-switch">
//               <input
//                 className="form-check-input"
//                 type="checkbox"
//                 id="flexSwitchCheckDefault"
//                 checked={tdsChecked}
//                 disabled={hasPrefillTds}
//                 onChange={(e) => {
//                   const checked = e.target.checked;
//                   setTdsChecked(checked);
//                   if (!checked) handleOnChange("tds_diduction", 0);
//                 }}
//               />
//               <label className="form-check-label" htmlFor="flexSwitchCheckDefault">
//                 {tdsChecked ? "Yes" : "No"}
//               </label>
//             </div>

//             {tdsChecked && (
//               <CustomSelect
//                 label="TDS Deduction %"
//                 value={

//                   tdsList.find((i) => i.value === formTotal.tds_diduction)

//                 }
//                 options={tdsList}
//                 onSelect={(data) => handleOnChange("tds_diduction", data?.value)}
//                 focus={!!formError?.tds_diduction}
//                 error={formError.tds_diduction}
//                 disabled={hasPrefillTds}
//               />
//             )}

//             {editData && (
//               <div className="_amtBaar">
//                 <p>TDS Amount</p>
//                 <p>{formatINR(tdsAmount)}</p>
//               </div>
//             )}
//           </div>
//         </div>
//       </CommonModal>
//     </div>
//   );
// };

// export default AddTotalFreightModal;


// import { handleKeyDown } from "_services";
// import { getSupplierDetailsData } from "_services/accountsServices/supplierServices";
// import { CommonInput, CommonModal, CustomSelect } from "components";
// import { UserContext } from "context";
// import { addTotalFrieght, editTotalFrieght } from "features";
// import { errorSchema, utils } from "helper";
// import React, { useContext, useEffect, useState } from "react";
// import { useDispatch } from "react-redux";
// import StorageService from "utils/StorageServices/StorageServices";

// const INITIAL_FORM = (tripId) => ({
//   trip_id: tripId,
//   freight_type: 6,
//   qty: "",
//   rate: "",
//   amount: "",
//   tds_diduction: 0,
// });

// const sanitizeNumericValue = (value) => {
//   if (/^0[0-9]/.test(value)) return value.replace(/^0+/, "");
//   return value;
// };

// const AddTotalFreightModal = (props) => {
//   const { editData, tripId, totalFreightDetails, closeModal, callbackTotal, tripDetais } = props;

//   const dispatch = useDispatch();
//   const { masterData } = useContext(UserContext);

//   const [tdsChecked, setTdsChecked] = useState(false);
//   const [tdsList, setTDsList] = useState([]);
//   const [freightTypeList, setFreightTypeList] = useState([]);
//   const [formTotal, setFormTotal] = useState(INITIAL_FORM(tripId));
//   const [formError, setFormError] = useState("");
//   const [isLoading, setIsLoading] = useState(false);
//   const [tdsAmount, setTdsAmount] = useState(0);
//   const [isInitialized, setIsInitialized] = useState(false);
//   const [tdsInputAmount, setTdsInputAmount] = useState("");  // ✅ new state
//   const [supplierDetails,setSupplierDetails] = useState("")

//   const hasPrefillTds =
//     (editData?.tds_deduction > 0) || (totalFreightDetails?.tds_deduction > 0);


//   useEffect(async () => {
//       const supplierDetails = await getDataSupplierDetails(tripDetais?.supplier_id?._id)
//       setSupplierDetails(supplierDetails)
//   }, [tripDetais])

//   console.log("supplierDetails",supplierDetails)

//   const getDataSupplierDetails = async (id_1) => {
//     try {

//       let object = {
//         supplier_id: id_1,
//       }
//       const res = await getSupplierDetailsData(object);
//       if (res?.responseCode == 200) {
//         return res?.data?.supplier

//       }
//     } catch (error) {

//     }
//   }

//   // Load master data
//   useEffect(() => {
//     console.log(masterData.supplier_tds_list)
//     if (!masterData) return;
//     setTDsList([
//       ...(masterData.supplier_tds_list?.map((item) => ({ label: item.name, value: item.id })) ?? []),
//       { label: "Custom", value: "" },  // ✅ Custom option
//     ]);
//     setFreightTypeList(
//       masterData.contract_rate_type_list?.map((item) => ({ label: item.name, value: item.id })) ?? []
//     );
//   }, [masterData]);

//   // Sync tripId
//   useEffect(() => {
//     setFormTotal((prev) => ({ ...prev, trip_id: tripId }));
//   }, [tripId]);

//   // Pre-fill form when editing
//   useEffect(() => {
//     const source = editData || totalFreightDetails;
//     if (!source) return;

//     const amount = editData?.total_freight ?? totalFreightDetails?.balance ?? "";
//     const tdsPercent = editData?.tds_deduction ?? totalFreightDetails?.tds_deduction ?? 0;

//     setFormTotal((prev) => ({
//       ...prev,
//       amount,
//       rate: editData?.rate ?? totalFreightDetails?.rate ?? "",
//       qty: editData?.qty ?? totalFreightDetails?.qty ?? "",
//       freight_type: editData?.freight_type ?? totalFreightDetails?.freight_type ?? 6,
//       tds_diduction: tdsPercent,
//     }));

//     // ✅ Initial TDS amount calculate karo
//     if (tdsPercent > 0 && amount > 0) {
//       setTdsInputAmount(((Number(amount) * Number(tdsPercent)) / 100).toFixed(2));
//     }

//     if (tdsPercent > 0) setTdsChecked(true);
//     setIsInitialized(true);
//   }, [totalFreightDetails, editData]);

//   // Auto-calculate amount from qty × rate
//   useEffect(() => {
//     if (formTotal.freight_type !== 6) {
//       setFormTotal((prev) => ({
//         ...prev,
//         amount: Number(prev.qty) * Number(prev.rate),
//       }));
//     }
//   }, [formTotal.rate, formTotal.qty]);

//   // Clear qty/rate only on user-driven freight type change
//   useEffect(() => {
//     if (!isInitialized) return;
//     if (formTotal.freight_type === 6) {
//       setFormTotal((prev) => ({ ...prev, rate: "", qty: "" }));
//     }
//   }, [formTotal.freight_type]);

//   // Recalculate TDS amount
//   useEffect(() => {
//     setTdsAmount(
//       Number(formTotal.amount) && Number(formTotal.tds_diduction)
//         ? (Number(formTotal.amount) * Number(formTotal.tds_diduction)) / 100
//         : 0
//     );
//   }, [formTotal.amount, formTotal.tds_diduction]);

//   const handleOnChange = async (name, value) => {
//     setFormTotal(prev => {
//       const stateObj = { ...prev, [name]: value };
//       return stateObj;
//     });

//     const stateObj = { ...formTotal, [name]: value };
//     if (formError) {
//       const result = await utils.checkFormError(stateObj, errorSchema.addTotalFreigthSchema);
//       setFormError(result === true ? "" : result);
//     }
//   };

//   const handleNumericChange = ({ target: { name, value } }) => {
//     handleOnChange(name, sanitizeNumericValue(value));
//   };

//   const onSubmit = async () => {
//     const validationResult = await utils.checkFormError(formTotal, errorSchema.addTotalFreigthSchema);

//     if (validationResult !== true) {
//       setFormError(validationResult);
//       return;
//     }

//     const payload = {
//       company_id: StorageService.getCompanyId(),
//       trip_id: tripId,
//       freight_type: formTotal.freight_type,
//       qty: Number(formTotal.qty),
//       rate: Number(formTotal.rate),
//       amount: Number(formTotal.amount),
//       tds_diduction: formTotal.tds_diduction || 0,
//     };

//     try {
//       setIsLoading(true);
//       const action = totalFreightDetails || editData ? editTotalFrieght : addTotalFrieght;
//       const res = await dispatch(action(payload));
//       if (res?.payload?.responseCode === 200) {
//         handleClose();
//         callbackTotal();
//       }
//     } catch {
//       // handle silently
//     } finally {
//       setIsLoading(false);
//     }
//   };

//   const handleClose = () => {
//     closeModal();
//     setFormTotal(INITIAL_FORM(tripId));
//     setIsInitialized(false);
//     setTdsChecked(false);
//     setTdsInputAmount("");  // ✅ reset
//   };

//   const formatINR = (value) =>
//     Number(value || 0).toLocaleString("en-IN", {
//       minimumFractionDigits: 2,
//       maximumFractionDigits: 2,
//     });

//   const selectedFreightType = freightTypeList.find((i) => i.value === formTotal.freight_type);
//   const isFixedFreight = formTotal.freight_type === 6;

//   return (
//     <div>
//       <CommonModal {...props} onSubmit={onSubmit} isLoading={isLoading} disabled={isLoading}>
//         <div className="addTotalFreight_body">
//           <div className="_qntSelector">
//             <CustomSelect
//               label="Freight Type"
//               options={freightTypeList}
//               onSelect={(data) => handleOnChange("freight_type", data?.value)}
//               value={selectedFreightType}
//               focus={!!formError?.freight_type}
//               error={formError.freight_type}
//             />
//           </div>

//           {!isFixedFreight ? (
//             <div className="_clmsFlex">
//               <div className="clmDual_fx">
//                 <CommonInput
//                   type="text"
//                   name="qty"
//                   label={selectedFreightType?.label ?? "Qty"}
//                   value={formTotal.qty}
//                   onChange={handleNumericChange}
//                   maxLength={12}
//                   onKeyDown={handleKeyDown}
//                   focus={!!formError?.qty}
//                   error={formError.qty}
//                 />
//               </div>
//               <div className="clmDual_fx">
//                 <CommonInput
//                   type="text"
//                   name="rate"
//                   label="Rate"
//                   value={formTotal.rate}
//                   onChange={handleNumericChange}
//                   maxLength={12}
//                   onKeyDown={handleKeyDown}
//                   focus={!!formError?.rate}
//                   error={formError.rate}
//                 />
//               </div>
//             </div>
//           ) : (
//             <CommonInput
//               type="text"
//               name="amount"
//               label={selectedFreightType?.label ?? "Qty"}
//               placeholder="Enter Freight"
//               value={formTotal.amount}
//               onChange={handleNumericChange}
//               maxLength={20}
//               onKeyDown={handleKeyDown}
//               focus={!!formError?.amount}
//               error={formError.amount}
//             />
//           )}

//           <div className="_amtBaar">
//             <p>Amount</p>
//             <p>{formatINR(formTotal.amount)}</p>
//           </div>

//           <div>
//             <span className="_tdsLabel">TDS Deduction</span>

//             <div className="form-check form-switch">
//               <input
//                 className="form-check-input"
//                 type="checkbox"
//                 id="flexSwitchCheckDefault"
//                 checked={tdsChecked}
//                 disabled={hasPrefillTds}
//                 onChange={(e) => {
//                   const checked = e.target.checked;
//                   setTdsChecked(checked);
//                   if (!checked) {
//                     handleOnChange("tds_diduction", 0);
//                     setTdsInputAmount("");
//                   }
//                 }}
//               />
//               <label className="form-check-label" htmlFor="flexSwitchCheckDefault">
//                 {tdsChecked ? "Yes" : "No"}
//               </label>
//             </div>

//             {/* ✅ TDS % Input + Dropdown combo */}
//             {/* {tdsChecked && (
//               <div className='singleDiv' style={{ position: 'relative' }}>
//                 <CommonInput
//                   type="text"
//                   label="TDS Deduction %"
//                   name='tds_diduction'
//                   value={formTotal?.tds_diduction || ""}
//                   onChange={({ target: { name, value } }) => {
//                     if (!/^(\d+(\.\d{0,2})?)?$/.test(value)) return;

//                     handleOnChange(name, value === "" ? 0 : value);

//                     // ✅ TDS amount auto calculate
//                     const calculated = value && formTotal?.amount
//                       ? ((Number(formTotal.amount) * Number(value)) / 100).toFixed(2)
//                       : "";
//                     setTdsInputAmount(calculated);
//                   }}
//                   onKeyDown={handleKeyDown}
//                   focus={!!formError?.tds_diduction}
//                   error={formError.tds_diduction}
//                 />

//                 <div className='__inrDropdown_bx' style={{ zIndex: 6 }}>
//                   <CustomSelect
//                     options={tdsList || []}
//                     placeholder="Select"
//                     value={
//                       formTotal?.tds_diduction === 0 || !formTotal?.tds_diduction
//                         ? tdsList?.find((i) => i?.value === 0)   // ← "No Deduction" (id:0)
//                         : tdsList?.find(
//                           (i) => i?.value !== 0 && String(i?.value) === String(formTotal?.tds_diduction)
//                         ) || { label: "Custom", value: "" }
//                     }
//                     onSelect={(data) => {
//                       if (data?.value === 0) {
//                         // No Deduction selected
//                         handleOnChange("tds_diduction", 0);
//                         setTdsInputAmount("");
//                       } else if (data?.value === "") {
//                         // Custom selected
//                         handleOnChange("tds_diduction", "");
//                         setTdsInputAmount("");
//                       } else {
//                         handleOnChange("tds_diduction", data?.value);
//                         const calculated = formTotal?.amount
//                           ? ((Number(formTotal.amount) * Number(data?.value)) / 100).toFixed(2)
//                           : "";
//                         setTdsInputAmount(calculated);
//                       }
//                     }}
//                   />
//                 </div>
//               </div>
//             )} */}

//             {/* ✅ TDS Amount Input */}
//             {/* {tdsChecked && (
//               <div className='singleDiv' style={{ marginTop: '12px' }}>
//                 <CommonInput
//                   type="text"
//                   label="TDS Amount"
//                   name="tds_amount_input"
//                   value={tdsInputAmount}
//                   onChange={({ target: { value } }) => {
//                     if (!/^(\d+(\.\d{0,2})?)?$/.test(value)) return;

//                     setTdsInputAmount(value);

//                     if (value && formTotal?.amount && Number(formTotal.amount) > 0) {
//                       const calculatedPercent = ((Number(value) / Number(formTotal.amount)) * 100).toFixed(2);
//                       const cleanPercent = parseFloat(calculatedPercent).toString();
//                       handleOnChange("tds_diduction", cleanPercent);
//                     } else {
//                       handleOnChange("tds_diduction", 0);
//                     }
//                   }}
//                   onKeyDown={handleKeyDown}
//                 />
//               </div>
//             )} */}
//             <CommonInput
//               type="text"
//               label="TDS Amount"
//               name="tds_amount_input"
//               value={tdsInputAmount}
//               onChange={({ target: { value } }) => {
//                 if (!/^(\d+(\.\d{0,2})?)?$/.test(value)) return;
//                 setTdsInputAmount(value);
//                 if (value && Number(formTotal.amount) > 0) {
//                   const pct = ((Number(value) / Number(formTotal.amount)) * 100).toFixed(2);
//                   handleOnChange("tds_diduction", parseFloat(pct).toString());
//                 } else {
//                   handleOnChange("tds_diduction", 0);
//                 }
//               }}
//               disabled={supplierDetails?.tds_deduction > 0}
//               onKeyDown={handleKeyDown}
//               rightElement={   // ✅ pills pass karo
//                 <div style={{ display: 'flex', gap: '5px' }}>
//                   {tdsList
//                     .filter(item => item.value === 1 || item.value === 2)
//                     .map(item => {
//                       const isActive = String(formTotal.tds_diduction) === String(item.value);
//                       return (
//                         <button
//                           key={item.value}
//                           type="button"
//                           onClick={() => {
//                             handleOnChange("tds_diduction", item.value);
//                             const amt = formTotal?.amount
//                               ? ((Number(formTotal.amount) * item.value) / 100).toFixed(2)
//                               : "";
//                             setTdsInputAmount(amt);
//                           }}
//                           style={{
//                             background: isActive ? '#7F77DD' : 'transparent',
//                             color: isActive ? '#fff' : 'var(--color-text-secondary)',
//                             border: isActive ? 'none' : '0.5px solid #ccc',
//                             borderRadius: '20px',
//                             padding: '3px 15px',
//                             fontSize: '12px',
//                             cursor: 'pointer',
//                             whiteSpace: 'nowrap',

//                           }}
//                           disabled={supplierDetails?.tds_deduction > 0}
//                         >
//                           {item.label}
//                         </button>
//                       );
//                     })}
//                 </div>
//               }
//             />
//             {editData && (
//               <div className="_amtBaar">
//                 <p>TDS Amount</p>
//                 <p>{formatINR(tdsInputAmount || tdsAmount)}</p>   {/* ← direct value */}
//               </div>
//             )}
//           </div>
//         </div>
//       </CommonModal>
//     </div>
//   );
// };

// export default AddTotalFreightModal;


import { handleKeyDown } from "_services";
import { getSupplierDetailsData } from "_services/accountsServices/supplierServices";
import { CommonInput, CommonModal, CustomSelect } from "components";
import { UserContext } from "context";
import { addTotalFrieght, editTotalFrieght } from "features";
import { errorSchema, utils } from "helper";
import Loading from "pages/Loading";
import React, { useContext, useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import StorageService from "utils/StorageServices/StorageServices";

const INITIAL_FORM = (tripId) => ({
  trip_id: tripId,
  freight_type: 6,
  qty: "",
  rate: "",
  amount: "",
  tds_diduction: 0,
});

const sanitizeNumericValue = (value) => {
  if (/^0[0-9]/.test(value)) return value.replace(/^0+/, "");
  return value;
};

const AddTotalFreightModal = (props) => {
  const { editData, tripId, totalFreightDetails, closeModal, callbackTotal, tripDetais } = props;

  const dispatch = useDispatch();
  const { masterData } = useContext(UserContext);

  const [tdsChecked, setTdsChecked] = useState(false);
  const [tdsList, setTDsList] = useState([]);
  const [freightTypeList, setFreightTypeList] = useState([]);
  const [formTotal, setFormTotal] = useState(INITIAL_FORM(tripId));
  const [formError, setFormError] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const [tdsAmount, setTdsAmount] = useState(0);
  const [isInitialized, setIsInitialized] = useState(false);
  const [tdsInputAmount, setTdsInputAmount] = useState("");
  const [supplierDetails, setSupplierDetails] = useState(null);
  const [isReady, setIsReady] = useState(false);

  // Supplier API sabse pehle
  useEffect(() => {
    let isMounted = true;

    const fetchSupplier = async () => {
      if (!tripDetais?.supplier_id?._id) {
        if (isMounted) setIsReady(true);
        return;
      }
      try {
        const data = await getDataSupplierDetails(tripDetais?.supplier_id?._id);
        if (isMounted) {
          setSupplierDetails(data);
          setIsReady(true);
        }
      } catch {
        if (isMounted) setIsReady(true); // error aaye tab bhi form dikhao
      }
    };

    fetchSupplier();

    return () => { isMounted = false; };
  }, [tripDetais]);

  const getDataSupplierDetails = async (id) => {
    try {
      const res = await getSupplierDetailsData({ supplier_id: id });
      if (res?.responseCode === 200) return res?.data?.supplier;
      return null;
    } catch {
      return null;
    }
  };

  // hasPrefillTds — supplier + editData + totalFreightDetails teeno check
  const hasPrefillTds =
    (supplierDetails?.tds_deduction > 0);
  // (editData?.tds_deduction > 0) ||
  // (totalFreightDetails?.tds_deduction > 0);

  // Load master data
  useEffect(() => {
    if (!masterData) return;
    setTDsList(
      masterData.supplier_tds_list?.map((item) => ({ label: item.name, value: item.id })) ?? []
    );
    setFreightTypeList(
      masterData.contract_rate_type_list?.map((item) => ({ label: item.name, value: item.id })) ?? []
    );
  }, [masterData]);

  // Sync tripId
  useEffect(() => {
    setFormTotal((prev) => ({ ...prev, trip_id: tripId }));
  }, [tripId]);

  // Pre-fill form when editing
  useEffect(() => {
    const source = editData || totalFreightDetails;
    if (!source) return;

    const amount = editData?.total_freight ?? totalFreightDetails?.balance ?? "";
    const tdsPercent = editData?.tds_deduction ?? totalFreightDetails?.tds_deduction ?? 0;

    setFormTotal((prev) => ({
      ...prev,
      amount,
      rate: editData?.rate ?? totalFreightDetails?.rate ?? "",
      qty: editData?.qty ?? totalFreightDetails?.qty ?? "",
      freight_type: editData?.freight_type ?? totalFreightDetails?.freight_type ?? 6,
      tds_diduction: tdsPercent,
    }));

    if (tdsPercent > 0 && amount > 0) {
      setTdsInputAmount(((Number(amount) * Number(tdsPercent)) / 100).toFixed(2));
    }

    if (tdsPercent > 0) setTdsChecked(true);
    setIsInitialized(true);
  }, [totalFreightDetails, editData]);

  // Auto-calculate amount from qty × rate
  useEffect(() => {
    if (formTotal.freight_type !== 6) {
      setFormTotal((prev) => ({
        ...prev,
        amount: Number(prev.qty) * Number(prev.rate),
      }));
    }
  }, [formTotal.rate, formTotal.qty]);

  // Clear qty/rate only on user-driven freight type change
  useEffect(() => {
    if (!isInitialized) return;
    if (formTotal.freight_type === 6) {
      setFormTotal((prev) => ({ ...prev, rate: "", qty: "" }));
    }
  }, [formTotal.freight_type]);

  // Recalculate TDS amount
  useEffect(() => {
    setTdsAmount(
      Number(formTotal.amount) && Number(formTotal.tds_diduction)
        ? (Number(formTotal.amount) * Number(formTotal.tds_diduction)) / 100
        : 0
    );
  }, [formTotal.amount, formTotal.tds_diduction]);

  const handleOnChange = async (name, value) => {
    setFormTotal((prev) => ({ ...prev, [name]: value }));
    const stateObj = { ...formTotal, [name]: value };
    if (formError) {
      const result = await utils.checkFormError(stateObj, errorSchema.addTotalFreigthSchema);
      setFormError(result === true ? "" : result);
    }
  };

  const handleNumericChange = ({ target: { name, value } }) => {
    handleOnChange(name, sanitizeNumericValue(value));
  };

  const onSubmit = async () => {
    const validationResult = await utils.checkFormError(formTotal, errorSchema.addTotalFreigthSchema);

    if (validationResult !== true) {
      setFormError(validationResult);
      return;
    }

    // const payload = {
    //   company_id: StorageService.getCompanyId(),
    //   trip_id: tripId,
    //   freight_type: formTotal.freight_type,
    //   qty: Number(formTotal.qty),
    //   rate: Number(formTotal.rate),
    //   amount: Number(formTotal.amount),
    //   tds_diduction: Number(formTotal.tds_diduction) || 0,
    //   tds_amount:Number(tdsAmount)
    // };

    const payload = {
      company_id: StorageService.getCompanyId(),
      trip_id: tripId,
      freight_type: formTotal.freight_type,
      qty: Number(formTotal.qty),
      rate: Number(formTotal.rate),
      amount: Number(formTotal.amount),
      tds_diduction: parseFloat(formTotal.tds_diduction) || 0,   // ✅ "2.86" → 2.86
      tds_amount: parseFloat(tdsInputAmount) || 0,                // ✅ "125.50" → 125.50
    };

    try {
      setIsLoading(true);
      const action = totalFreightDetails || editData ? editTotalFrieght : addTotalFrieght;
      const res = await dispatch(action(payload));
      if (res?.payload?.responseCode === 200) {
        handleClose();
        callbackTotal();
      }
    } catch {
      // handle silently
    } finally {
      setIsLoading(false);
    }
  };

  const handleClose = () => {
    closeModal();
    setFormTotal(INITIAL_FORM(tripId));
    setIsInitialized(false);
    setTdsChecked(false);
    setTdsInputAmount("");
    setSupplierDetails(null);
    setIsReady(false);
  };

  const formatINR = (value) =>
    Number(value || 0).toLocaleString("en-IN", {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    });

  const selectedFreightType = freightTypeList.find((i) => i.value === formTotal.freight_type);
  const isFixedFreight = formTotal.freight_type === 6;

  return (
    <div>
      <CommonModal {...props} onSubmit={onSubmit} isLoading={isLoading} disabled={isLoading || !isReady}>

        {!isReady ? (
          <div style={{
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            minHeight: '200px'
          }}>
            <div colSpan="100%" className="loaderBg" style={{ textAlign: "center" }}> <Loading /></div>
          </div>
        ) : (
          <div className="addTotalFreight_body">

            <div className="_qntSelector">
              <CustomSelect
                label="Freight Type"
                options={freightTypeList}
                onSelect={(data) => handleOnChange("freight_type", data?.value)}
                value={selectedFreightType}
                focus={!!formError?.freight_type}
                error={formError.freight_type}
              />
            </div>

            {!isFixedFreight ? (
              <div className="_clmsFlex">
                <div className="clmDual_fx">
                  <CommonInput
                    type="text"
                    name="qty"
                    label={selectedFreightType?.label ?? "Qty"}
                    value={formTotal.qty}
                    onChange={handleNumericChange}
                    maxLength={12}
                    onKeyDown={handleKeyDown}
                    focus={!!formError?.qty}
                    error={formError.qty}
                  />
                </div>
                <div className="clmDual_fx">
                  <CommonInput
                    type="text"
                    name="rate"
                    label="Rate"
                    value={formTotal.rate}
                    onChange={handleNumericChange}
                    maxLength={12}
                    onKeyDown={handleKeyDown}
                    focus={!!formError?.rate}
                    error={formError.rate}
                  />
                </div>
              </div>
            ) : (
              <CommonInput
                type="text"
                name="amount"
                label={selectedFreightType?.label ?? "Qty"}
                placeholder="Enter Freight"
                value={formTotal.amount}
                onChange={handleNumericChange}
                maxLength={20}
                onKeyDown={handleKeyDown}
                focus={!!formError?.amount}
                error={formError.amount}
              />
            )}

            <div className="_amtBaar">
              <p>Amount</p>
              <p>{formatINR(formTotal.amount)}</p>
            </div>

            <div>
              <span className="_tdsLabel">TDS Deduction</span>

              <div className="form-check form-switch">
                <input
                  className="form-check-input"
                  type="checkbox"
                  id="flexSwitchCheckDefault"
                  checked={tdsChecked}
                  // disabled={hasPrefillTds}
                  onChange={(e) => {
                    const checked = e.target.checked;
                    setTdsChecked(checked);
                    if (!checked) {
                      handleOnChange("tds_diduction", 0);
                      setTdsInputAmount("");
                    }
                  }}
                />
                <label className="form-check-label" htmlFor="flexSwitchCheckDefault">
                  {tdsChecked ? "Yes" : "No"}
                </label>
              </div>

              {tdsChecked && (
                <CommonInput
                  type="text"
                  label="TDS Amount"
                  name="tds_amount_input"
                  value={tdsInputAmount}
                  // disabled={hasPrefillTds}
                  onChange={({ target: { value } }) => {
                    if (!/^(\d+(\.\d{0,2})?)?$/.test(value)) return;
                    setTdsInputAmount(value);
                    if (value && Number(formTotal.amount) > 0) {
                      const pct = (Number(value) / Number(formTotal.amount)) * 100;
                      handleOnChange("tds_diduction", pct);                                     // ✅ string nahi, number store karo
                      handleOnChange("tds_diduction", pct);
                    } else {
                      handleOnChange("tds_diduction", 0);
                    }
                  }}
                  onKeyDown={handleKeyDown}
                  rightElement={
                    <div style={{ display: 'flex', gap: '5px' }}>
                      {tdsList
                        .filter((item) => item.value === 1 || item.value === 2)
                        .map((item) => {
                          const isActive = String(formTotal.tds_diduction) === String(item.value);
                          return (
                            <button
                              key={item.value}
                              type="button"
                              // disabled={hasPrefillTds}
                              onClick={() => {
                                handleOnChange("tds_diduction", item.value);
                                const amt = formTotal?.amount
                                  ? ((Number(formTotal.amount) * item.value) / 100).toFixed(2)
                                  : "";
                                setTdsInputAmount(amt);
                              }}
                              style={{
                                background: isActive ? '#7F77DD' : 'transparent',
                                color: isActive ? '#fff' : '#888',
                                border: isActive ? 'none' : '0.5px solid #ccc',
                                borderRadius: '20px',
                                padding: '3px 15px',
                                fontSize: '12px',
                                cursor: 'pointer',
                                whiteSpace: 'nowrap',
                                opacity:  1,
                              }}
                            >
                              {item.label}
                            </button>
                          );
                        })}
                    </div>
                  }
                />
              )}

              {editData && (
                <div className="_amtBaar">
                  <p>TDS Amount</p>
                  <p>{formatINR(tdsInputAmount || tdsAmount)}</p>
                </div>
              )}
            </div>

          </div>
        )}

      </CommonModal>
    </div>
  );
};

export default AddTotalFreightModal;